import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PreviousBar from "../component/PreviousBar"
import Dialog from "@mui/material/Dialog";
import CancelIcon from '@mui/icons-material/Cancel';
import { changeTypeToName } from "../helper/changeBankIdtoName";
import { useNavigate } from "react-router-dom";
import { deleteTicketList, getNumberSet } from "../features/lotteryInvoice";
import CancelPresentationSharpIcon from '@mui/icons-material/CancelPresentationSharp';
const Modal = (props) => {
  const [Open, setOpen] = useState(false);
  const handleChange = () => {
    setOpen(!Open);
    // console.log(Open)
  };
  return (
    <React.Fragment>
      <button
        className="text-right bg-defaultText5 text-white p-1 rounded"
        onClick={handleChange}
      >
        แสดงรายละเอียด
      </button>
      <Dialog
        id={props.data.id}
        fullWidth={true}
        fullScreen={true}
        maxWidth="md"
        open={Open}
        onClose={handleChange}
        aria-labelledby="max-width-dialog-title"
      >
        {/* <DialogContent> */}
        <div className="w-full px-1">
          <div className="flex justify-between mb-1 mx-1">
            <p className="text-lg font-bold">เลขชุด</p>
            <button onClick={handleChange}>
              <CancelIcon />
            </button>
          </div>

          <p>ชื่อชุด: {props.data.setName}</p>
          <p>
            สร้างเมื่อ:{" "}
            {new Date(props.data.createDatetime).toLocaleDateString(
              "th-TH"
            )}
          </p>
        </div>
        <div className="grid grid-cols-3 bg-[#b3853e] text-center text-white mt-2">
          <p>ลำดับ</p>
          <p>ประเภท</p>
          <p>ตัวเลข</p>
        </div>
        {props.data.ticketList?.map((ticket, i) => (
          <div key={i} className="grid grid-cols-3 py-1 border-b text-center text-[#b3853e]    mt-2">
            <p>{i + 1}</p>
            <p>{changeTypeToName(ticket.betType)}</p>
            <p>{ticket.betNumber}</p>
          </div>
        ))}
      </Dialog>
    </React.Fragment>
  );
};

const Betnumset = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const numset = useSelector((state) => state.invoice.numset);
  const deleteList = async (id) => {
    const data = { id: id };
    let check = window.confirm("คุณแน่ใจที่จะลบเลขชุดนี้ใช่ไหม ?");
    if (check) {
      await dispatch(deleteTicketList(data));
      dispatch(getNumberSet());
    }
  };
  useEffect(() => {
    dispatch(getNumberSet());
  }, []);

  return (
    <div>
      <PreviousBar name="จัดการเลขชุด" toDashboard/>
      <div className="w-full flex justify-end px-2">
        <button
          className=" bg-green-600 rounded px-2 py-1 my-3 text-white text-sm"
          onClick={() => navigate("/setnumber")}
        >
          สร้างเลขชุด
        </button>
      </div>
      <div className="grid grid-cols-4 text-center bg-[#b3853e] py-1 text-white text-sm">
        <p>ชื่อชุด</p>
        <p>วันที่สร้าง</p>
        <p className="col-span-2">รายละเอียด</p>
      </div>

      {numset?.length ? (
        numset?.map((ticket, i) => (
          <div key={i} className="grid grid-cols-4 text-center py-2 text-[#b3853e] text-sm font-bold border-b">
            <p className="mt-1">{ticket.setName}</p>
            <p className="mt-1">
              {new Date(ticket.createDatetime).toLocaleDateString("th-TH")}
            </p>
            <div className="col-span-2 px-2 flex justify-around">
              <Modal data={ticket} />
              <button onClick={() => deleteList(ticket._id)}>
                <CancelPresentationSharpIcon />
              </button>
            </div>
          </div>
        ))
      ) : (
        <p className="col-span-4 text-center mt-5 text-[#b3853e]">ไม่มีรายการ</p>
      )}
    </div>
  )
}

export default Betnumset